import React from 'react';

import {
    Link
} from 'react-router-dom'

import {
    Container,
    Segment,
    Image,
    Header,
    List,
    Grid,
    Input,
    Form,
    Icon,
} from 'semantic-ui-react';

import { translate } from 'react-translate';

import { HashLink as ScrollLink } from 'react-router-hash-link';

import './footer.css'

import API from '../../services/api';


class FooterComponent extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            mailNewsLetter: "",
        }

        this.submitNews = this.submitNews.bind(this);
        this.onChangeMailNews = this.onChangeMailNews.bind(this);
    }

    onChangeMailNews(e, data) {
        e.preventDefault();
        this.setState({
            mailNewsLetter: data.value
        })
    }

    submitNews(e) {
        e.preventDefault();
        if (this.state.mailNewsLetter === "") {

        } else {
            var form = new FormData();
            form.append("subject", "newsletter");
            form.append("email", this.state.mailNewsLetter);
            API.sendMail(this.props.token, form).then((res) => {
            });
        }
    }



    render() {
        const { t } = this.props
        return (
            <div>
                <Segment inverted vertical id="segmentFooter">
                    <Container textAlign='center'>
                        <Grid relaxed inverted stackable columns={4} padded>
                            <Grid.Column textAlign='left' id="columnFooter" mobile={16} tablet={8} computer={4}>
                                <Header inverted as='h3'>{t("Header1_title")}</Header>
                                <List relaxed inverted link>
                                    <Link to='/'><List.Item id="listItemFooter">{t("ListItem1_title")}</List.Item></Link>
                                    <Link to='/functions'><List.Item id="listItemFooter">{t("ListItem3_title")}</List.Item></Link>
                                    <Link to='/pro'><List.Item id="listItemFooter">{t("ListItem4_title")}</List.Item></Link>
                                    <ScrollLink to='/#thirdContentNew' smooth={true} duration={500} style={{cursor: 'pointer'}}>
                                      <List.Item id="listItemFooter">{t("ListItem2_title")}</List.Item>
                                    </ScrollLink>
                                    <Link to='/contact'><List.Item id="listItemFooter">{t("ListItem5_title")}</List.Item></Link>
                                </List>
                            </Grid.Column>
                            <Grid.Column textAlign='left' id="columnFooter" mobile={16} tablet={8} computer={4}>
                                <Header inverted as='h3'>{t("Header2_title")}</Header>
                                <List relaxed inverted link>
                                    <Link to='/Support'><List.Item id="listItemFooter">{t("ListItem6_title")}</List.Item></Link>
                                    <Link to='/partenaire'><List.Item id="listItemFooter" > {t("ListItem7_title")}</List.Item></Link>
                                    <Link to='/cguv'><List.Item id="listItemFooter"> {t("ListItem8_title")}</List.Item></Link>
                                    <Link to='/termsandconditions'><List.Item id="listItemFooter"> {t("ListItem9_title")}</List.Item></Link>
                                </List>
                            </Grid.Column>
                            <Grid.Column textAlign='left' id="columnFooter" mobile={16} tablet={8} computer={4}>
                                <Header inverted as='h3'>{t("Header3_title")}</Header>
                                <List inverted link>
                                    <List.Item id="listItemFooter"><a href="tel:+33183622541">+33 1 83 62 25 41</a></List.Item>
                                    <List.Item id="listItemFooter"><a href="mailto:contact@mytravo.net">contact@mytravo.net</a></List.Item>
                                    <a href='https://www.facebook.com/mytravo.fr/'>
                                      <List.Item id="listItemFooter" ><Icon circular name='facebook' size='small' /> {t("ListItem11_title")}</List.Item>
                                    </a>
                                    <a href='https://www.linkedin.com/company/mytravo/'>
                                      <List.Item id="listItemFooter" ><Icon circular name='linkedin' size='small' />  {t("ListItem13_title")}</List.Item>
                                    </a>
                                </List>
                            </Grid.Column>
                            <Grid.Column id="columnFooter" textAlign='left' mobile={16} tablet={8} computer={4}>
                                <Header textAlign='left' inverted as='h3'>{t("Header4_title")}</Header>
                                <List relaxed inverted link>
                                    <List.Item id="listItemFooter" >{t("ListItem14_title")}</List.Item>
                                    <Form onSubmit={this.submitNews} id="newsletter">
                                      <Form.Input onChange={this.onChangeMailNews} type="email" action={{ icon: 'long arrow right' }} placeholder='Votre e-mail' />
                                      <p><input type="checkbox" required name="terms" /> {t("newsletter_agreement")} <Link to='/termsandconditions'>{t("ListItem9_title")}</Link>. </p>
                                    </Form>
                                </List>
                            </Grid.Column>
                        </Grid>
                    </Container>
                </Segment>
                <Segment size='huge' inverted id="bottomFooter" vertical>
                    <Container text textAlign='center'>
                        <Header inverted as='h5'>{t("Header5_title")}</Header>
                    </Container>
                </Segment>
            </div>
        )
    }
}

export default translate("FooterComponent")(FooterComponent);



// WEBPACK FOOTER //
// ./src/components/Public/FooterComponent.js